/**
 * Modos do seletor de contexto de Carteiras — a lista onde o usuário procura o que vai abrir.
 *
 * O literal é CONTRATO entre três camadas: `client-search.vue` grava o modo, a store o persiste em
 * `walletSelectorMode` e `isFamilyGroupView` decide a visão a partir dele. Enquanto a constante vivia
 * só no componente, a store comparava contra `'familias'`/`'clientes'` por CÓPIA — renomear o modo no
 * seletor deixaria a store respondendo `false` para sempre, sem erro nenhum.
 *
 * O valor também vai para o `localStorage` (`group-selection-storage`), então mudar um literal aqui
 * invalida a preferência salva de quem já escolheu o modo.
 */
export const FILTER_MODE = {
  CLIENTES: 'clientes',
  LEADS: 'leads',
  FAMILIAS: 'familias',
}
